import { render, staticRenderFns } from "./ValidateTSDetails.vue?vue&type=template&id=d05d88c4&scoped=true&"
import script from "./ValidateTSDetails.vue?vue&type=script&lang=js&"
export * from "./ValidateTSDetails.vue?vue&type=script&lang=js&"
import style0 from "./ValidateTSDetails.vue?vue&type=style&index=0&id=d05d88c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05d88c4",
  null
  
)

export default component.exports